import React, { type FC } from "react";
import { BusinessList } from "@src/components/business-list";
import { ListItem } from "@src/components/business-list";
import { BusinessLotValue, BusinessMeasureValue, BusinessStockObjValue } from "@src/components/business-data-display";
import { OverflowMarquee } from "@src/shared/ui";
import type { UseStockFinishedGoodsShipmentContentsQueryResult } from "../../hooks";
import {
    formatShipmentCellsFromSpMovings,
    formatShipmentOrderText,
} from "../../helpers/formatStockFinishedGoodsShipmentContent";

/** Пропсы компонента {@link StockFinishedGoodsShipmentContentsList}. */
interface StockFinishedGoodsShipmentContentsListProps {
    /** Query-result строк НС. */
    contentsQuery: UseStockFinishedGoodsShipmentContentsQueryResult;
    /**
     * Открывает форму отгрузки продукции.
     * @param contentCode код строки НС
     */
    onOpenContent: (contentCode: number) => void;
}

/** Список строк НС для отгрузки готовой продукции со склада СГП. */
export const StockFinishedGoodsShipmentContentsList: FC<StockFinishedGoodsShipmentContentsListProps> = ({
    contentsQuery,
    onOpenContent,
}) => {
    const { content, isFetching } = contentsQuery;

    return (
        <BusinessList isLoad={isFetching} emptyText="Список строк НС пуст">
            {content.map((item) => {
                return (
                    <ListItem
                        key={item.Code}
                        tone={item.ConfirmLeave ? "success" : "default"}
                        title={<BusinessStockObjValue stockObj={item.StockObj} mode="wrap" />}
                        props={[
                            {
                                label: "Подтверждение отгрузки",
                                value: item.ConfirmLeave ? "Да" : "Нет",
                            },
                            {
                                label: "Количество",
                                value: <BusinessMeasureValue value={item.Qty} measure={item.Measure} />,
                            },
                            {
                                label: "Заказ",
                                value: <OverflowMarquee>{formatShipmentOrderText(item.Order)}</OverflowMarquee>,
                            },
                            {
                                label: "Партия",
                                value: <BusinessLotValue lot={item.Lot} />,
                            },
                            {
                                label: "Ячейки размещения",
                                value: <OverflowMarquee>{formatShipmentCellsFromSpMovings(item.SpMovings)}</OverflowMarquee>,
                            },
                        ]}
                        onClick={() => {
                            onOpenContent(item.Code);
                        }}
                    />
                );
            })}
        </BusinessList>
    );
};
